import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { nString } from '@hidat/huijs-common';
import * as dompurify from 'dompurify';

//https://github.com/cure53/DOMPurify/issues/1034
// @ts-ignore
const purifier = dompurify['default'] as dompurify.DOMPurify;

export const purify = (s: string, cfg?: dompurify.Config) => {
  return purifier.sanitize(s, cfg) as string;
};

const template = `
<div class="safe-html-wrapper">
    <div [innerHTML]="sanitizedHtml()"></div>
</div>
`;

@Component({
  selector: 'hng-safe-html',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HngSafeHtmlComponent {
  public htmlString = input<nString>();
  protected sanitizer = inject(DomSanitizer);

  sanitizedHtml = computed(() => {
    let oStr: SafeHtml | undefined;
    const iStr = this.htmlString();
    if (iStr) {
      oStr = this.sanitizer.bypassSecurityTrustHtml(
        purify(iStr, { USE_PROFILES: { html: true } }),
      );
    }
    return oStr;
  });
}
